import { render, staticRenderFns } from "./Health-Dot.vue?vue&type=template&id=8c99c414&lang=pug"
import script from "./Health-Dot.vue?vue&type=script&lang=ts"
export * from "./Health-Dot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports